<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><img alt="images" src="images/f008-01.jpg" width="80%"/></p>
<p class="caption"><em class="italic">Major General Sir Fabian Arthur Ware</em>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_fm021.vue?fffc6bda